module.exports = "<div ng-bind-html=\"$ctrl.content\"></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/mobile-connect/mobile-connect.html
// module id = 573
// module chunks = 0